module.exports = __webpack_public_path__ + "assets/f88645b5f27cb6d9a16f4394585454ad.png";